module.exports = __webpack_public_path__ + "AvertaStd-ThinItalic.svg?9e58df23a39bce5a9664823053bea1b1";